import React, { Component, useContext } from 'react'
import Pills from '@app/components/ui/controls/Pills'
import PropTypes from 'prop-types'
import { Teacher } from '@app/models/users'

import { AbilityContext } from '@app/context/ability-context'
import { teacherTabs } from '@app/helpers/menusHelper'

const PillsMenu = ({ teacher, route }) => {
  const ability = useContext(AbilityContext);

  return (
    <div className="submenu">
      <Pills
        items={teacherTabs(ability, route)}
        route={route}
      />
    </div>
  )
}

PillsMenu.propTypes = {
  teacher: PropTypes.instanceOf(Teacher).isRequired,
  route: PropTypes.object.isRequired
}

export default PillsMenu
